import { contactIdKeys } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const eventHasContact = (event, contact) =>
  contactIdKeys.some(key => event[key] === contact.id);



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/DeleteContactModal/utils.js